class CardProductInteractive extends HTMLElement {
  constructor() {
    super()
    this.swiperInstance = null
    this.swiperContainer = this.querySelector('.swiper')
    this.swiperWrapper = this.querySelector('#swiper-wrapper')
    this.initializeSwiper()

    this.swiperContainer.addEventListener("mouseover", (event) => {
      this.swiperInstance.slideTo(1)
    })

    this.swiperContainer.addEventListener("mouseout", (event) => {
      this.swiperInstance.slideTo(0)
    })

  }

  initializeSwiper() {
    this.swiperInstance = new Swiper(this.swiperContainer, {
      loop: true,
      enabled: true,
      slideInView: 1,
      slidesToMove: 1,
      autoplay: false,
      speed: 500,
      grabCursor: false,
      effect: "fade",
      stackMobile: false,
      freeModeMobile: false,
      no_swipe_mobile: false,
      fadeEffect: {
        crossFade: true,
      },

      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    })

  }

}

customElements.define('card-product-interactive', CardProductInteractive)


//  &quot;slideInView&quot;: &quot;auto&quot;,
//   &quot;slidesToMove&quot;: 1,
//   &quot;loop&quot;: true,
//   &quot;autoplay&quot;: false,
//   &quot;speed&quot;: 500,
//   &quot;grabCursor&quot;: false,
//   &quot;effect&quot;: &quot;fade&quot;,
//   &quot;blockLength&quot;: 7,
//   &quot;stackMobile&quot;: false,
//   &quot;freeModeMobile&quot;: false,
//   &quot;no_swipe_mobile&quot;: false